/**
 * @file AgendaAssignment class is a wrapper of PlanItem from the backend api towards the Agenda.
 * @author Wim Haanstra
 */
import * as tslib_1 from "tslib";
import { PlanItemWrapper } from './plan-item-wrapper';
/** AgendaAssignment class is a wrapper of the PlanItem entity containing an Assignment entity. */
var AgendaAssignment = /** @class */ (function (_super) {
    tslib_1.__extends(AgendaAssignment, _super);
    /**
     * Constructs a AgendaAssignment.
     * @param item The PlanItem being wrapped.
     */
    function AgendaAssignment(item) {
        return _super.call(this, item) || this;
    }
    Object.defineProperty(AgendaAssignment.prototype, "projectName", {
        /** Gets the project name of the wrapped PlanItem. */
        get: function () {
            var navProperty = this.item;
            AgendaAssignment.pathToProject.find(function (segment) {
                navProperty = navProperty[segment];
                return (navProperty === undefined || navProperty === null); // Stop when dead end.
            });
            if (navProperty) {
                return navProperty[this.nameProperty];
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgendaAssignment.prototype, "customerName", {
        /** Gets the customer name of the wrapped PlanItem. */
        get: function () {
            var navProperty = this.item;
            AgendaAssignment.pathToCustomer.find(function (segment) {
                navProperty = navProperty[segment];
                return (navProperty === undefined || navProperty === null); // Stop when dead end.
            });
            if (navProperty) {
                return navProperty[this.nameProperty];
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the appropriate collection of the given timeslot for this AgendaAssignment class.
     */
    AgendaAssignment.prototype.getCollectionOf = function (timeSlot) {
        var flag = this.item.Item[AgendaAssignment.appointmentProperty];
        if (flag) {
            return timeSlot.gridAppointments;
        }
        return timeSlot.gridAssignments;
    };
    /**
     * Create a copy of this instance.
     */
    AgendaAssignment.prototype.makeCopy = function () {
        var copy = new AgendaAssignment(this.item);
        copy.covers = this.covers;
        copy.zIndex = this.zIndex;
        return copy;
    };
    /** The path to navigate towards the project of an Assignment. */
    AgendaAssignment.pathToProject = [
        'Item',
        'Deployment',
        'Demand',
        'Task',
        'Project'
    ];
    /** The name of the appointment property. */
    AgendaAssignment.appointmentProperty = 'Appointment';
    /** The path to navigate towards the customer of an Assignment. */
    AgendaAssignment.pathToCustomer = [
        'Item',
        'Customer'
    ];
    return AgendaAssignment;
}(PlanItemWrapper));
export { AgendaAssignment };
